import { useContext, useMemo, useState } from 'react'
import ReactQuill from 'react-quill'
import * as FEATURES from '../../../../constants/features'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { toastSuccess } from '../../../../utils/toast'
import { setPageTitle } from '../../../../utils/utilities'
import './styles.css'

const Scanner = () => {
  setPageTitle('Content | Scanner')
  const { [SETTINGS.FEATURES.key]: enabledFeatures } =
    useContext(SiteConfigContext)
  const scannerEnabled = useMemo(
    () => enabledFeatures && enabledFeatures[FEATURES.SCANNER],
    [enabledFeatures]
  )

  if (!scannerEnabled) {
    return (
      <div className="flex flex-col gap-2">
        <h2>Scanner is not enabled</h2>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-5">
      <ScannerGuide />
    </div>
  )
}

const ScannerGuide = () => {
  const { [SETTINGS.SCANNER_GUIDE.key]: theGuide, updateSetting } =
    useContext(SiteConfigContext)
  const [tmpGuide, setTmpGuide] = useState(theGuide)

  const handleSubmit = async (e) => {
    e.preventDefault()
    await updateSetting(SETTINGS.SCANNER_GUIDE, tmpGuide)
    toastSuccess('Scanner Guide content saved!')
  }

  return (
    <div className="flex flex-col gap-2.5">
      <h2>Scanner Guide</h2>
      <form
        onSubmit={handleSubmit}
        autoComplete="off"
        className="flex flex-col gap-2.5"
      >
        <ReactQuill
          id="terms"
          name="terms"
          style={{ height: '420px', width: '100%' }}
          aria-label="Scanner Guide content"
          placeholder="Scanner Guide content"
          defaultValue={theGuide}
          onChange={setTmpGuide}
          modules={{
            toolbar: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['link'],
              ['clean']
            ]
          }}
          formats={[
            'header',
            'bold',
            'italic',
            'underline',
            'strike',
            'blockquote',
            'list',
            'bullet',
            'link'
          ]}
        />
        <button
          type="submit"
          aria-label="Save"
          className="button-confirm w-fit"
        >
          Save
        </button>
      </form>
    </div>
  )
}

export default Scanner
